/** Site-wide links (audit: WhatsApp CTA, social, canonical base). */
/** Canonical site URL (www). Used for meta tags, JSON-LD, sitemap, and canonical links. */
import brandLogoFull from "../assets/brand-logo.png";

export const SITE_ORIGIN = "https://www.rencindesign.com";
export const CONTACT_EMAIL = "rencindesign@gmail.com";
export const WHATSAPP_E164 = "919082278436";
export const CONTACT_PHONE_DISPLAY = "9082278436";
export const CONTACT_PHONE_E164 = `91${CONTACT_PHONE_DISPLAY}`;
export const INSTAGRAM_URL = "https://www.instagram.com/rencingifting/";

/** Application logo — bundled so deploy always ships the asset. */
export const APP_LOGO = brandLogoFull;
export const APP_LOGO_FULL = brandLogoFull;
export const APP_LOGO_ALT = "Rencin Design";

/** Homepage full-bleed banner video (place file at public/bannervideo.mp4). */
export const HOME_BANNER_VIDEO = `${process.env.PUBLIC_URL || ""}/bannervideo.mp4`;
export const HOME_BANNER_VIDEO_REVERSE = `${process.env.PUBLIC_URL || ""}/bannervideo-reverse.mp4`;
export const HOME_BANNER_POSTER = `${process.env.PUBLIC_URL || ""}/brand/hero-banner.jpg`;

export const BUSINESS_NAME = "Nadar Scientilla Stephen";
export const BUSINESS_CARE_OF = "Stephen Nadar";
export const UDYAM_REGISTRATION_NUMBER = "UDYAM-MH-33-0797266";
export const BUSINESS_ADDRESS_LINES = [
  "Flat No. 2005/A, Building No. 28, Gaurav Samruddhi",
  "Off Mira Bhayander Road, Mira Road East",
  "Near GCC Club, Thane",
  "Mira Road, Thane, Maharashtra — 401107",
];

export function businessAddressMultiline() {
  return BUSINESS_ADDRESS_LINES.join("\n");
}

export function whatsAppChatUrl(prefillText) {
  const base = `https://wa.me/${WHATSAPP_E164}`;
  if (!prefillText || !String(prefillText).trim()) return base;
  return `${base}?text=${encodeURIComponent(String(prefillText).trim())}`;
}
